export const fileToBase64 = async (fileToConvert: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(fileToConvert);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });
};

export const base64ToBlob = (fileConvertedToBase64: string): string => {
  const byteCharacters = atob(fileConvertedToBase64.split(",")[1] || fileConvertedToBase64);
  const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
  const byteArray: Uint8Array = new Uint8Array(byteNumbers);
  const blob: Blob = new Blob([byteArray], { type: "application/pdf" });
  const blobUrl: string = URL.createObjectURL(blob);
  return blobUrl;
};

export const openPdfInNewTab = (blobUrl: string): void => {
  window.open(blobUrl, "_blank");
};
